import { render, staticRenderFns } from "./BidTypeDropdownField.vue?vue&type=template&id=59ac5930"
import script from "./BidTypeDropdownField.vue?vue&type=script&lang=ts"
export * from "./BidTypeDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ac5930')) {
      api.createRecord('59ac5930', component.options)
    } else {
      api.reload('59ac5930', component.options)
    }
    module.hot.accept("./BidTypeDropdownField.vue?vue&type=template&id=59ac5930", function () {
      api.rerender('59ac5930', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/BidTypeDropdownField.vue"
export default component.exports